var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-opacity:0;}\r\n\t.st1{fill:#F58B23;}\r\n\t.st2{fill:#290000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 4,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.9,11h12.1c0.5,0,0.9,0.4,0.9,0.9v0.1c0,0.5-0.4,0.9-0.9,0.9H7.9C7.4,13,7,12.6,7,12.1v-0.1 C7,11.4,7.4,11,7.9,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.9,16h16.1c0.5,0,0.9,0.4,0.9,0.9v0.1c0,0.5-0.4,0.9-0.9,0.9H3.9C3.4,18,3,17.6,3,17.1v-0.1 C3,16.4,3.4,16,3.9,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.9,6h16.1C20.6,6,21,6.4,21,6.9v0.1C21,7.6,20.6,8,20.1,8H3.9C3.4,8,3,7.6,3,7.1V6.9C3,6.4,3.4,6,3.9,6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBtn);
export default __webpack_public_path__ + "static/media/menu-btn.c4b0a15f2983a4ffb69a3a95b34cc759.svg";
export { ForwardRef as ReactComponent };